module.exports = __webpack_public_path__ + "static/media/user-cowboy.c05138bf.svg";